import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../images/farminlogo.jpeg";

import {
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";

function Navbar({ setPage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [investorOpen, setInvestorOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const changePage = (page) => {
    setPage(page);
    setMenuOpen(false);
    setProductOpen(false);
    setInvestorOpen(false);
  };

  return (
    <>
      {/* ================= NAVBAR ================= */}

      <nav className={`navbar ${scrolled ? "navbar-scroll" : ""}`}>

        {/* Logo */}

        <div
          className="logo"
          onClick={() => changePage("home")}
        >
          <img src={logo} alt="Farmin Logo" />

          <div className="logo-text">
            <h2>FARMIN</h2>
          </div>
        </div>

        {/* Desktop Menu */}

        <ul className="nav-links">

          <li onClick={() => changePage("home")}>
            HOME
          </li>

          <li onClick={() => changePage("about")}>
            ABOUT US
          </li>

          {/* Products */}

          <li className="dropdown">

            <button className="drop-btn">
              OUR PRODUCTS
              <FaChevronDown className="arrow" />
            </button>

            <ul className="dropdown-menu">

              <li onClick={() => changePage("flyash")}>
                Fly Ash Bricks
              </li>

              <li onClick={() => changePage("paver")}>
                Paver Blocks
              </li>

              <li onClick={() => changePage("stone")}>
                Stone Aggregate
              </li>

              <li onClick={() => changePage("aac")}>
                AAC Blocks
              </li>

            </ul>

          </li>

          <li onClick={() => changePage("group")}>
            OUR GROUP
          </li>

          {/* Investors */}

          <li className="dropdown">

            <button className="drop-btn">
              INVESTORS
              <FaChevronDown className="arrow" />
            </button>

            <ul className="dropdown-menu">

              <li onClick={() => changePage("announcement")}>
                Corporate Announcement
              </li>

              <li onClick={() => changePage("financial")}>
                Financial Information
              </li>

              <li onClick={() => changePage("shareholding")}>
                Shareholding Pattern
              </li>

              <li onClick={() => changePage("governance")}>
                Corporate Governance
              </li>

              <li onClick={() => changePage("policies")}>
                Policies
              </li>

            </ul>

          </li>

          <li onClick={() => changePage("media")}>
            MEDIA
          </li>

          <li onClick={() => changePage("contact")}>
            CONTACT US
          </li>

        </ul>

        {/* Hamburger / Close */}

        <div
          className="menu-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

      </nav>
            {/* Overlay */}

      {menuOpen && (
        <div
          className="overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}

      {/* ================= MOBILE SIDEBAR ================= */}

      <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>

        <ul>

          <li onClick={() => changePage("home")}>
            HOME
          </li>

          <li onClick={() => changePage("about")}>
            ABOUT US
          </li>

          {/* Products */}

          <li
            className="mobile-dropdown-title"
            onClick={() => setProductOpen(!productOpen)}
          >
            <span>OUR PRODUCTS</span>

            <FaChevronDown
              className={`mobile-arrow ${
                productOpen ? "rotate" : ""
              }`}
            />
          </li>

          {productOpen && (
            <ul className="mobile-submenu">

              <li onClick={() => changePage("flyash")}>
                Fly Ash Bricks
              </li>

              <li onClick={() => changePage("paver")}>
                Paver Blocks
              </li>

              <li onClick={() => changePage("stone")}>
                Stone Aggregate
              </li>

              <li onClick={() => changePage("aac")}>
                AAC Blocks
              </li>

            </ul>
          )}

          <li onClick={() => changePage("group")}>
            OUR GROUP
          </li>

          {/* Investors */}

          <li
            className="mobile-dropdown-title"
            onClick={() => setInvestorOpen(!investorOpen)}
          >
            <span>INVESTORS</span>

            <FaChevronDown
              className={`mobile-arrow ${
                investorOpen ? "rotate" : ""
              }`}
            />
          </li>

          {investorOpen && (
            <ul className="mobile-submenu">

              <li onClick={() => changePage("announcement")}>
                Corporate Announcement
              </li>

              <li onClick={() => changePage("financial")}>
                Financial Information
              </li>

              <li onClick={() => changePage("shareholding")}>
                Shareholding Pattern
              </li>

              <li onClick={() => changePage("governance")}>
                Corporate Governance
              </li>

              <li onClick={() => changePage("policies")}>
                Policies
              </li>

            </ul>
          )}

          <li onClick={() => changePage("media")}>
            MEDIA
          </li>

          <li onClick={() => changePage("contact")}>
            CONTACT US
          </li>

        </ul>

      </div>

    </>
  );
}

export default Navbar;